exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".showInModal{\n    padding-left: 5px;\n    padding-top: 0px;\n    padding-right: 5px;\n}\n\n.img-keepAspect {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n.modal-big {\n    max-width: 80% !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/home-card-center-show/home-card-center-show.component.css
// module id = 411
// module chunks = 0